<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Harvester Sites</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Company</th>
                        <th>Name</th>
                        <th>Total Production</th>
                        <th>Average Daily Production</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="site in sites" v-if="sites.length" :key="site.id" class="text-left">
                        <td class="text-capitalize">{{ site.company_name ?? 'N/A' }}</td>
                        <td class="text-capitalize">{{ site.name }}</td>
                        <td>{{ parseFloat(site.total_production ?? 0).toFixed(1) }} kWh</td>
                        <td>{{ parseFloat(site.avg_daily_production ?? 0).toFixed(1) }} kWh</td>
                        <td class="text-capitalize">{{ site.description }}</td>
                        <td>
                            <v-icon :icon="site.status?'mdi-check':'mdi-close'"/>
                        </td>
                        <td class="text-capitalize">{{ (new Date(site.created_at)).toLocaleDateString() }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <!--<v-btn :disabled="harvestersDialogSwitch" prepend-icon="mdi-account-multiple"
                                       size="x-small" @click="siteAssets(site)">Harvesters
                                </v-btn>-->
                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editSite(site)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteSite(site)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="8">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="8">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchSites"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create
        v-if="createDialogSwitch"
        v-model="createDialogSwitch"
        @addSite="addSite"
    />
    <Edit
        v-if="editDialogSwitch"
        v-model="editDialogSwitch"
        :site="selectedSite"
        @updateSiteData="updateSite"
    />

</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Edit from "@/components/dialogs/harvesters/sites/Edit.vue";
import Create from "@/components/dialogs/harvesters/sites/Create.vue";

const sites = ref([]);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const selectedSite = ref(null);
const {showSnackbar} = useSnackbarStore();
const editDialogSwitch = ref(false);
const createDialogSwitch = ref(false);
const harvestersDialogSwitch = ref(false);

onMounted(() => {
    fetchSites();
});

const fetchSites = () => {
    loading.value = true;
    send('get', `harvesters/sites`, {page: currentPage.value})
        .then((response) => {
            sites.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('sites could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addSite = (site) => {
    sites.value.unshift(site);
}
const editSite = (site) => {
    selectedSite.value = site;
    editDialogSwitch.value = true;
}
const updateSite = (site) => {
    let index = sites.value.findIndex(item => item.id === site.id);
    sites.value[index]['name'] = site['name'];
    sites.value[index]['status'] = site['status'];
    sites.value[index]['company_id'] = site['company_id'];
    sites.value[index]['description'] = site['description'];
    sites.value[index]['company_name'] = site['company_name'];
    sites.value[index]['polygon_coordinates'] = site['polygon_coordinates'];
}
const deleteSite = (site) => {
    if (confirm(`Are you sure to delete "${site.name}" site?`)) {
        send('delete', `harvesters/sites/${site.id}`)
            .then((response) => {
                if (response.data.success) {
                    sites.value.map((item, index) => {
                        if (item.id === site.id) {
                            sites.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${site.name}" Asset site could not be deleted`, 'error')
                }
            })
    }
}

const siteAssets = (site) => {
    selectedSite.value = site;
    harvestersDialogSwitch.value = true;
}

const newAssets = () => {
    fetchSites();
}
</script>
